import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default class AlertDialog extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            title: '',
            description: ''
        }
    }

    render() {
        const { open, title, description, handleOkClicked } = this.props
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {description}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {/*                         <Button onClick={this.handleClose} color="primary">
                            Disagree
                  </Button> */}
                        <Button onClick={handleOkClicked} color="primary" autoFocus>
                            Ok
                  </Button>
                    </DialogActions>
                </Dialog>
            </div >
        )
    }

/*    handleClickOpen() {
        this.setState((prevState) => ({
            ...prevState,
            open: true
        }))
    }

    handleClose() {
        this.setState((prevState) => ({
            ...prevState,
            open: false
        }))
    }*/

}